export default __webpack_public_path__ + "static/media/space-light.9a0953fbd9a22850daa5b966dad084d8.jpg";